import PropTypes from "prop-types";
import CheckboxQuestion from "../QuestionTypes/CheckboxQuestion";
import LongTextQuestion from "../QuestionTypes/LongTextQuestion";
import RadioQuestion from "../QuestionTypes/RadioQuestion";
import ShortAnswerQuestion from "../QuestionTypes/ShortAnswerQuestion";
import { memo } from "react";

const typeMap = {
  SHORT_TEXT: ShortAnswerQuestion,
  LONG_TEXT: LongTextQuestion,
  RADIO: RadioQuestion,
  CHECKBOX: CheckboxQuestion,
};

const QuestionWrapper = memo(({ question, updateQuestion, canEdit }) => {
  const Component = typeMap[question.fieldType];

  return <Component question={question} updateQuestion={updateQuestion} canEdit={canEdit} />;
});

QuestionWrapper.propTypes = {
  question: PropTypes.shape({
    formId: PropTypes.number,
    questionText: PropTypes.string,
    fieldType: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    options: PropTypes.string,
    orderIndex: PropTypes.number,
  }).isRequired,
  updateQuestion: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
};

export default QuestionWrapper;
